"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// import { tryApiFetchNoJson } from "./utils/utils";
var defaults_1 = __importDefault(require("./defaults"));
var errors_1 = require("./utils/errors");
var logger_1 = __importDefault(require("./utils/logger"));
var logger = logger_1.default('auth-tester-class');
/**
 * Authorization class for sounditi client Tester WebProject
 *
 * It manages directly the localStorage to save {@link TokenPair}
 *
 * @param {string} campaignId the campaignId for the testing session
 * @param {Object} config
 * @param {string} [config.tester_host=defaults.tester_host] host for the api, defaults to: {@link defaultconfig}
 *
 * @category ClientDataLayers
 *
 * @example
 *  // INITIALIZE THE OBJECT
 *  const testerAuth = new TesterAuth();
 *  //SET THE CAMPAIGN ==> GET THIS FROM THE URL/OR SUBDOMAIN INFO
 *  const campaignId = 'test-campaign';
 *  testerAuth.setCampaign(campaignId)
 *  // LOG/SIGNUP a user
 *  const loginResponse = await testerAuth.login('todeleted@tester.com', '1234');
 */
var TesterAuth = /** @class */ (function () {
    function TesterAuth(config) {
        var _this = this;
        /**
         * Checks that the scope provided is correct
         * @private
         */
        this.init = function () {
            var validScopes = ['tester'];
            if (!validScopes.includes(_this.scope))
                throw new Error('The scope provided is not valid.');
        };
        /**
         * Returns the tokenKey name
         * @private
         */
        this.getTokenKey = function () {
            return _this.tokenKey;
        };
        /**
         * Returns the renewalTokenKey name
         * @private
         */
        this.getRenewalTokenKey = function () {
            return _this.renewalTokenKey;
        };
        /**
         * Returns the tokenKey name
         * @private
         */
        this.getCampaignKey = function () {
            return _this.campaignKey;
        };
        /**
         * Removes the tokenPair from local storage
         */
        this.removeToken = function () {
            window.localStorage.removeItem(_this.tokenKey);
            window.localStorage.removeItem(_this.renewalTokenKey);
            window.localStorage.removeItem(_this.expirationKey);
        };
        /**
         * saves the token session in localstorage
         */
        this.setToken = function (tokenPair, expirationT) {
            window.localStorage.setItem(_this.tokenKey, tokenPair.accessToken);
            window.localStorage.setItem(_this.renewalTokenKey, tokenPair.renewalToken);
            window.localStorage.setItem(_this.expirationKey, expirationT);
        };
        this.setCampaign = function (campaignId) {
            window.localStorage.setItem(_this.campaignKey, campaignId);
        };
        this.getCampaign = function () {
            return window.localStorage.getItem(_this.campaignKey) || '';
        };
        /**
         * retrieves the token from localStorage
         */
        this.getToken = function () {
            return window.localStorage.getItem(_this.tokenKey) || '';
        };
        /**
         * retrieves the renewalToken from localStorage
         */
        this.getRenewalToken = function () {
            return window.localStorage.getItem(_this.renewalTokenKey);
        };
        this.checkTokenExpiration = function () {
            var tokenExpiration = window.localStorage.getItem(_this.expirationKey);
            if (!tokenExpiration)
                return true;
            return new Date().getTime() > 1000 * parseInt(tokenExpiration);
        };
        var tester_host = __assign(__assign({}, defaults_1.default), config).tester_host;
        this.host = tester_host;
        this.scope = 'tester';
        this.tokenKey = "snd-token-tester";
        this.campaignKey = "snd-campaign";
        this.renewalTokenKey = "snd-renewalToken-tester";
        this.expirationKey = "snd-expiration-tester";
    }
    /**
     * Signs up a tester in FT2-TesterApp
     *
     * @param {string} name tester provided name
     * @param {string} email user email
     * @param {string} password user plainText pasword
     * @param {string} gender gender of the tester either "male" or "female"
     * @param {string} birthDate date of birth, should be in the format "YYYY-MM-DD"
     * @param {string} [lead = 'organic'] lead to track origin of testers
     *
     * @returns {object} {created: boolean, credentials: LoginResponse}
     * @throws {NotFoundError}
     * @todo enforce password and email validation
     */
    TesterAuth.prototype.signUp = function (name, email, password, gender, birthDate, linkId, sessionId, country, city, lead) {
        if (country === void 0) { country = null; }
        if (city === void 0) { city = null; }
        if (lead === void 0) { lead = 'organic'; }
        return __awaiter(this, void 0, void 0, function () {
            var campaignId, response, json, responseObject, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        campaignId = this.getCampaign();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 8, , 9]);
                        return [4 /*yield*/, fetch(this.host + "/tester/signup", {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({ name: name, email: email, password: password, campaignId: campaignId, gender: gender, birthDate: birthDate, lead: lead, linkId: linkId, sessionId: sessionId, country: country, city: city }),
                            })];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        json = _a.sent();
                        if (!(response.status === 409)) return [3 /*break*/, 4];
                        throw new Error(json.message);
                    case 4:
                        if (!(response.status === 400)) return [3 /*break*/, 5];
                        throw new errors_1.NotFoundError(json.message);
                    case 5:
                        if (!(response.status === 200)) return [3 /*break*/, 7];
                        if (!!json.quotaFullRedirect) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.setToken(json.credentials.auth, json.credentials.decoded.exp)];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7:
                        responseObject = json;
                        return [2 /*return*/, responseObject];
                    case 8:
                        error_1 = _a.sent();
                        throw error_1;
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Logs an user in FT2 with tester scope/token
     *
     * @param {string} email
     * @param {string} password
     *
     * @returns {Promise<LoginResponse>}
     *
     * @throws {LoginError}
     *
     */
    TesterAuth.prototype.login = function (email, password) {
        return __awaiter(this, void 0, void 0, function () {
            var campaignId, response, json, responseObject, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        campaignId = this.getCampaign();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 7, , 8]);
                        return [4 /*yield*/, fetch(this.host + "/tester/login", {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({ campaignId: campaignId, email: email, password: password }),
                            })];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        json = _a.sent();
                        if (!(response.status === 200)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.setToken(json.auth, json.decoded.exp)];
                    case 4:
                        _a.sent();
                        responseObject = json;
                        return [2 /*return*/, responseObject];
                    case 5: throw new errors_1.LoginError(json.message);
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        error_2 = _a.sent();
                        logger.error('error', { error: error_2 });
                        throw error_2;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Reactivate a 'deleted' tester
     * User should use his old password and email
     *
     * @param {string} email
     * @param {string} password
     *
     * @returns {Promise<Response>}
     *
     * @throws {LoginError}
     * @todo send email with token for renewal
     */
    TesterAuth.prototype.reactivate = function (email, password) {
        return __awaiter(this, void 0, void 0, function () {
            var campaignId, response, json, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        campaignId = this.getCampaign();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch(this.host + "/tester/reactivate", {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({ campaignId: campaignId, email: email, password: password }),
                            })];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        json = _a.sent();
                        return [2 /*return*/, json];
                    case 4:
                        error_3 = _a.sent();
                        logger.error('error', { error: error_3 });
                        throw error_3;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Set the satus of a user to deleted
     * No real deletion in DB
     * @returns {Promise<Response>}
     *
     * @throws {LoginError}
     *
     */
    TesterAuth.prototype.delete = function () {
        return __awaiter(this, void 0, void 0, function () {
            var token, response, json, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        token = this.getToken();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch(this.host + "/tester", {
                                method: 'DELETE',
                                headers: {
                                    "Authorization": "Bearer " + token
                                }
                            })];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        json = _a.sent();
                        return [2 /*return*/, json];
                    case 4:
                        error_4 = _a.sent();
                        logger.error('error', { error: error_4 });
                        throw error_4;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * peeks a public ROOT file
     * only public ROOT files will return 200
     * other campaign files will return NotFoundError
     *
     * @param {string} userId the user that owns the campaign
     * @param {string} fileName
     *
     * @returns {Promise<SAS>} Shared access credentials
     *
     * @throws {NotFoundError}
     */
    TesterAuth.prototype.peekFile = function (userId, fileName) {
        return __awaiter(this, void 0, void 0, function () {
            var response, json, json, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 6, , 7]);
                        return [4 /*yield*/, fetch(this.host + "/tester/peekfile?fileName=" + fileName + "&userId=" + userId, {
                                method: 'GET'
                            })];
                    case 1:
                        response = _a.sent();
                        if (!(response.status === 200)) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _a.sent();
                        return [2 /*return*/, json];
                    case 3: return [4 /*yield*/, response.json()];
                    case 4:
                        json = _a.sent();
                        throw new errors_1.NotFoundError(json.message);
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        error_5 = _a.sent();
                        logger.error('error', { error: error_5 });
                        throw error_5;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * sets a new password for a user
     *
     * @param oldPassword
     * @param newPassword
     *
     * @returns LoginResponse
     *
     * @todo invalidate old tokens
     */
    TesterAuth.prototype.updatePassword = function (oldPassword, newPassword) {
        return __awaiter(this, void 0, void 0, function () {
            var token, response, json, responseObject, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 7, , 8]);
                        return [4 /*yield*/, this.getToken()];
                    case 1:
                        token = _a.sent();
                        return [4 /*yield*/, fetch(this.host + "/tester/updatepassword", {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': "Bearer " + token
                                },
                                body: JSON.stringify({ oldPassword: oldPassword, newPassword: newPassword }),
                            })];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        json = _a.sent();
                        if (!(response.status === 200)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.setToken(json.auth || {}, json.decoded.exp || '')];
                    case 4:
                        _a.sent();
                        responseObject = json;
                        return [2 /*return*/, responseObject];
                    case 5: throw new Error(json.message);
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        error_6 = _a.sent();
                        throw new Error(error_6);
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    ;
    return TesterAuth;
}());
exports.default = TesterAuth;
//# sourceMappingURL=AuthTester.js.map